import styled from 'styled-components';

import { breakpoint } from 'DesignLibrary/global';

export const ClaimsButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--sizing-xs);

  button.selected {
    background: var(--primary-blue);
    border-color: var(--primary-blue);
    color: var(--primary-white);
  }
`;

export const ClaimsFormContainer = styled.div`
  .paragraph {
    margin-top: var(--sizing-md);
    margin-bottom: var(--sizing-xs);
  }

  .claims-policyholder-options {
    fieldset label {
      width: auto;
    }
  }

  .medium-width {
    max-width: 333px;
  }

  .member-id-tooltip {
    position: absolute;
    left: initial;
    right: var(--chakra-space-4);

    ${breakpoint.MOBILE} {
      left: calc(var(--chakra-space-5) * -1);
      right: initial;
    }
  }
`;

export const MemberIdLabelContainer = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const ClaimsPayerContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: var(--sizing-xs);
  align-items: center;
  background: var(--colors-blue-50);
  justify-content: space-between;
  border-radius: 0.5rem;
  padding: 0.5rem 1rem;

  .paragraph {
    margin: 0;
  }

  button {
    background: transparent;
    border: 0;
  }

  &:has(button:disabled) {
    background: #f5f5f7;
  }
`;

export const ClaimsOuter = styled.div`
  &:has(.claims-form-container) {
    .claims-button-container {
      button:first-child {
        background: var(--primary-blue);
        border-color: var(--primary-blue);
        color: var(--primary-white);
      }
      button:first-child:disabled {
        background: var(--text-black);
        opacity: 0.5;
        border: none;
        color: #fff;
        pointer-events: none;
      }
    }
  }

  input[disabled=''][checked] + .pseudo-toggle,
  button.selected:disabled {
    background: var(--text-black);
    opacity: 0.5;
    border: none;
    color: #fff;
    pointer-events: none;
  }

  input:disabled,
  button:disabled {
    background: #f5f5f7;
    border-color: #bebeca;
    color: var(--text-black);
    pointer-events: none;
    opacity: 0.5;
  }

  .loading-submit-button:disabled {
    background-color: #e0e0e5;
    border: none;
    opacity: 1;

    span div:first-child {
      margin-top: 1rem;
    }
  }

  .hidden {
    visibility: hidden;
  }
`;

export const SpinnerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;
